"use client";

// Real authentication client backed by the Rails Devise + JWT API.
// The JWT is captured automatically by apiClient from the sign-in response's
// Authorization header and stored under "auth.token"; every API request then
// sends it. This replaces the template's in-memory demo client.

import { apiClient, ApiError } from "@/api/client";

function mapUser(raw) {
	if (!raw) return null;
	return {
		id: raw.id,
		email: raw.email,
		name: raw.display_name || raw.email,
		avatar: raw.avatar, // not provided by the API yet; Avatar falls back gracefully
	};
}

// Invite-only: there is no registration or self-serve password reset; accounts
// are provisioned by an admin.
class AuthClient {
	async signInWithPassword({ email, password }) {
		try {
			// apiClient stores the JWT from the response Authorization header.
			const data = await apiClient.post("/api/auth/sign_in", { user: { email, password } });
			return { data: { user: mapUser(data?.user) } };
		} catch (error) {
			const message = error instanceof ApiError ? "Invalid email or password" : "Sign in failed";
			return { error: message };
		}
	}

	async getUser() {
		if (!apiClient.getToken()) {
			return { data: { user: null } };
		}
		try {
			const data = await apiClient.get("/api/auth/user");
			return { data: { user: mapUser(data?.user) } };
		} catch {
			apiClient.clearToken();
			return { data: { user: null } };
		}
	}

	async signOut() {
		try {
			await apiClient.delete("/api/auth/sign_out");
		} catch {
			// ignore — clear the local token regardless
		} finally {
			apiClient.clearToken();
		}
		return {};
	}
}

export const authClient = new AuthClient();
